export type EstimatedRateLevel = 'normal' | 'warning' | 'error';

export function getEstimatedRateLevel(
  price: number | string,
  estimatedMin: number | null | undefined,
  estimatedMax: number | null | undefined
): EstimatedRateLevel {
  if (estimatedMin == null || estimatedMax == null) return 'normal';

  const numericPrice = Number(price);
  const numericMin = Number(estimatedMin);
  const numericMax = Number(estimatedMax);

  if (
    !Number.isFinite(numericPrice) ||
    !Number.isFinite(numericMin) ||
    !Number.isFinite(numericMax) ||
    numericMax <= 0 ||
    numericMin > numericMax
  ) {
    return 'normal';
  }

  if (numericPrice > numericMax * 10) return 'error';
  if (numericPrice > numericMax * 4) return 'warning';
  return 'normal';
}
